import React, {useState, useEffect} from 'react'
import ClimbingBoxLoader from "react-spinners/ClimbingBoxLoader";


const PreLoader = ()=>{

    return <ClimbingBoxLoader color="#fff" size={20} />;
}

export default PreLoader;